module.exports = "/static/fonts/SimplerPro_V3-Bold.07ff681.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SimplerPro_V3-Bold.otf
// module id = wM4m
// module chunks = 6